import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import queryString from 'query-string';
import Select from 'react-select';
import * as formActions from 'shared/actions/searchForm';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toLocalized } from 'shared/helpers/locale';
import history from '../../../../../history';
import s from './SortLine.css';

class SortLine extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    //
    intl: intlShape.isRequired,
  };

  handleCurrencyChange = currency => {
    this.props.selectedActions.set.currency(currency);
    this.updateSearch('currency', currency.id);
  };

  handleOrderingChange = ordering => {
    this.props.selectedActions.set.ordering(ordering);
    this.updateSearch('ordering', ordering.id);
  };

  updateSearch = (param, value) => {
    const { locale } = this.props;
    const { search, pathname } = history.location;
    const query = {
      ...queryString.parse(search),
      [param]: value,
    };
    const url = `${pathname}?${queryString.stringify(query)}`;

    history.push(toLocalized(url, locale));
  };

  render() {
    const { formVocabulary, formState, type, intl } = this.props;
    const ordering = formVocabulary ? formVocabulary.ordering[type] : [];
    const formattedOrdering = ordering.map(({ title, ...props }) => ({
      ...props,
      title: intl.formatMessage({ id: title }),
    }));

    const selected =
      formState.ordering && formState.ordering.title === ordering[0].title
        ? { title: intl.formatMessage({ id: `${formState.ordering.title}` }) }
        : formState.ordering;

    return (
      <div className={s.root}>
        <div className={s.flexRow}>
          <div className={s.ordering}>
            <Select
              instanceId="ordering-ff"
              name="ordering"
              options={formattedOrdering}
              labelKey="title"
              valueKey="id"
              searchable={false}
              clearable={false}
              onChange={this.handleOrderingChange}
              value={selected}
            />
          </div>
          <div className={s.currency}>
            <Select
              instanceId="currency-ff"
              name="currency"
              options={formVocabulary.currency}
              labelKey="title"
              valueKey="slug"
              searchable={false}
              clearable={false}
              onChange={this.handleCurrencyChange}
              value={formState.currency}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ searchForm, globals }) => ({
  formState: searchForm && searchForm.selected,
  formVocabulary: searchForm && searchForm.vocabulary,
  locale: globals.locale,
});

const mapDispatchToProps = dispatch => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...formActions.selectedActions.set,
        ...formActions.carSetThunks,
      },
      dispatch,
    ),
  },
});

export default withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(injectIntl(SortLine)));



// WEBPACK FOOTER //
// ./src/desktop/routes/spareparts/components/SortLine/SortLine.js